import { useEffect, useState, useRef } from "react"
import styles from "./notice.module.less";
import { Util,Hooks,Request,XtLocale } from "@xt/xtbase";
const {getOrigin,moment,getUrl} = Util;
moment.locale("en");
const {useTranslation} = Hooks;
const {XtAxios} = Request;
import IconZhanneixin from "../img/icon/zhanneixin";

// 与 @xt/Notify AutoNoti 保持一致：同一套接口与 localStorage 判断逻辑
const AUTO_SPOT_NOTIFY_LOCAL_KEY = "autoSpotNotifyLocal";
const LETTER_NOTICE_PARAMS = { pushPage: 1, pageSize: 20, pageIndex: 1 };

function getStoredTime() {
  try {
    const raw = localStorage.getItem(AUTO_SPOT_NOTIFY_LOCAL_KEY);
    if (!raw) return null;
    const { time } = JSON.parse(raw);
    return typeof time === "number" ? time : null;
  } catch (e) {
    return null;
  }
}

/** 根据 Notify 的 time 判断“新消息”数量：createTime >= time 的条数；无 time 则全部算新 */
function getNewCount(list, storedTime) {
  if (!list || !list.length) return 0;
  if (storedTime == null) return list.length;
  return list.filter((item) => item.createTime >= storedTime).length;
}

/** 与 Notify AutoNoti 一致：写入“已读”时间，用于下次判断是否为新消息 */
function setStoredTimeNow() {
  try {
    localStorage.setItem(AUTO_SPOT_NOTIFY_LOCAL_KEY, JSON.stringify({ value: 1, time: Date.now() }));
  } catch (e) {}
}

export default function NavbarPcNotice(props) {
  const [noticeList, setNoticeList] = useState([]);
  const [storedTime, setStoredTime] = useState(null);
  const t = useTranslation();
  const timerRef = useRef(null);

  const fetchNoticeList = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    const lang = (XtLocale.intl && XtLocale.intl.locale) || "en";
    XtAxios.get(getOrigin("www") + "/xt-message/public/letter-notice/list", {
      params: { ...LETTER_NOTICE_PARAMS, lang },
      isAutoPopError: false,
    })
      .then((list) => {
        if (Array.isArray(list)) setNoticeList(list);
        setStoredTime(getStoredTime());
      })
      .catch(() => {})
      .finally(() => {
        timerRef.current = setTimeout(fetchNoticeList, 10000);
      });
  };

  useEffect(() => {
    setStoredTime(getStoredTime());
    fetchNoticeList();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const onNoticeLinkClick = () => {
    setStoredTimeNow();
    setStoredTime(Date.now());
  };

  const onClickMsg = (item) => {
    setStoredTimeNow();
    setStoredTime(Date.now());
    const { type, webClickUrl } = item;
    if (webClickUrl) {
      window.open(webClickUrl);
    } else {
      location.href = getUrl("/notification") + (type ? "?type=" + type : "");
    }
  };

  const unreadNum = getNewCount(noticeList, storedTime);
  return (
    <div className={styles["app-navbar-pc-notice"]}>
      <a href={getUrl("/notification")} onClick={onNoticeLinkClick}>
        <IconZhanneixin style={{"width":"20px","height":"20px"}}/>
        {unreadNum ? <i></i> : null}
      </a>
      {unreadNum ? <div className={styles.iMenu}>
        <p style={{"borderBottom":"1px solid rgba(245, 246, 250, 0.10196078431372549)"}}
          dangerouslySetInnerHTML={{ __html: t('header.noticeCountTip', [unreadNum]) }}>
        </p>
        <div className={styles.iUl} style={{height:unreadNum < 4 ? unreadNum * 81 + 'px' : '324px',overflowY:"scroll"}}>
          {!noticeList.length ? <p>{t("header.noticeNoneTip")}</p> : <>
            {noticeList.map((item,index)=>{
              return <div className={styles.iLi} key={"letter_" + (item.id || index)} onClick={()=>{onClickMsg(item)}}>
                <p>{ item.title }</p>
                <div>{ item.content }</div>
                <div>{ moment(item.createTime).format("YYYY-MM-DD HH:mm:ss") }</div>
              </div>
            })}
          </>}
        </div>
        <a href={getUrl("/notification")} onClick={onNoticeLinkClick} style={{
          "borderTop":"1px solid rgba(245, 246, 250, 0.1)"
        }}>
          { t("header.moreNotice") }
        </a>
      </div> : null}
    </div>
  )
}
